import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../../../context';
import {useApiClient} from '../../base/hooks/useApiClient';
import {ArrowLeft, Lock, User} from "lucide-react";
import {Button} from "../home/components/Navigation";
import {useTranslation} from "react-i18next";

export function LoginPage() {
    const { t } = useTranslation();
    const [formError, setFormError] = useState<string | undefined>();
    const [emailOrUsername, setEmailOrUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();
    const apiClient = useApiClient();

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        const response = await apiClient.post('login', { emailOrUsername, password });

        if (!response.ok) {
            const { error } = await response.json();
            setFormError(error);

            return;
        }

        const { token } = await response.json();
        login(token);

        navigate('/panel');
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 py-12 px-4 sm:px-6 lg:px-8">
            <button
                onClick={() => navigate('/')}
                className="absolute top-4 left-4 flex items-center text-white hover:text-indigo-100 transition-colors"
            >
                <ArrowLeft className="h-5 w-5 mr-2" />
                Back to Home
            </button>

            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h2>
                    <p className="text-gray-600">Sign in to continue to SAI</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {formError && (
                        <p className="text-sm text-red-600 mb-2">
                            {formError}
                        </p>
                    )}

                    <div>
                        <label htmlFor="emailOrUsername" className="block text-sm font-medium text-gray-700 mb-2">
                            Email or Username
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <User className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                                id="emailOrUsername"
                                type="text"
                                value={emailOrUsername}
                                onChange={(e) => setEmailOrUsername(e.target.value)}
                                className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                placeholder="your email or username"
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                            Password
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <Lock className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                placeholder="••••••••"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex items-center justify-end">
                        {/*<div className="flex items-center">*/}
                        {/*    <input*/}
                        {/*        id="remember-me"*/}
                        {/*        type="checkbox"*/}
                        {/*        className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"*/}
                        {/*    />*/}
                        {/*    <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">*/}
                        {/*        Remember me*/}
                        {/*    </label>*/}
                        {/*</div>*/}
                        <a href="/reset-password" className="text-sm font-medium text-indigo-600 hover:text-indigo-500">
                            Forgot password?
                        </a>
                    </div>

                    <Button primary className="w-full">
                        Sign In
                    </Button>
                </form>
            </div>
        </div>
    );
}
